var _rect, _path, _path2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUrine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.24414,
    y: 3,
    width: 54,
    height: 55,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2441 5H16.2441C10.169 5 5.24414 9.92487 5.24414 16V44C5.24414 50.0751 10.169 55 16.2441 55H44.2441C50.3193 55 55.2441 50.0751 55.2441 44V16C55.2441 9.92487 50.3193 5 44.2441 5ZM16.2441 0C7.40759 0 0.244141 7.16344 0.244141 16V44C0.244141 52.8366 7.40758 60 16.2441 60H44.2441C53.0807 60 60.2441 52.8366 60.2441 44V16C60.2441 7.16344 53.0807 0 44.2441 0H16.2441Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2441 14H23.7441H20.2441ZM41.2441 14H37.7441H41.2441ZM37.7441 14H23.7441H37.7441ZM37.7441 14V22.8889V14ZM23.7441 14V22.8889V14ZM23.7441 22.8889V38.8889C23.7441 40.7749 24.4816 42.5836 25.7944 43.9172C27.1071 45.2508 28.8876 46 30.7441 46C32.6007 46 34.3811 45.2508 35.6939 43.9172C37.0066 42.5836 37.7441 40.7749 37.7441 38.8889V22.8889H23.7441ZM23.7441 22.8889H37.7441H23.7441Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7441,
    cy: 31.5,
    r: 1.5,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.2441,
    cy: 37,
    r: 1,
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrine);
export default __webpack_public_path__ + "static/media/urine.68625512d04a7f9149cfaf4a670dc818.svg";
export { ForwardRef as ReactComponent };